import { gql } from "graphql-tag";

export const networkQualityThresholdFieldsFragment = gql`
  fragment NetworkQualityThresholdFields on NetworkQualityThreshold {
    metric
    unit
    levels {
      green {
        operator
        value
      }
      orange {
        operator
        value
      }
      red {
        operator
        value
      }
    }
  }
`;
